import React from 'react';
import {
  HeaderText as UiHeaderText,
  HeaderTextProps,
} from '@make-software/cspr-ui';

export const HeaderText = (props: HeaderTextProps) => (
  <UiHeaderText scale={'xs'} {...props} />
);
